import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface GlobeIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const GlobeIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: GlobeIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3 12H21"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 3C14.2511 5.46452 15.5305 8.66283 15.6 12C15.5305 15.3372 14.2511 18.5355 12 21C9.74884 18.5355 8.46952 15.3372 8.39999 12C8.46952 8.66283 9.74884 5.46452 12 3Z"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default GlobeIcon
